import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const SearchForm = ({ filter: initialFilter, category: initialCategory, onSubmit }) => {
    const [filter, setFilter] = useState(initialFilter);
    const [category, setCategory] = useState(initialCategory);

    useEffect(() => {
        setFilter(initialFilter);
        setCategory(initialCategory);
    }, [initialFilter, initialCategory]);

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit({ filter, category });
    };

    return (
        <form className="row" onSubmit={handleSubmit}>
            <div className="col-12 col-md-8 mb-3">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by product"
                        value={filter}
                        onChange={(event) => setFilter(event.target.value)}
                    />
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by category"
                        value={category}
                        onChange={(event) => setCategory(event.target.value)}
                    />
                </div>
            </div>
            <div className="btn-group col-12 col-md-4 mb-3">
                <Link className="btn btn-outline-secondary" to="/search">
                    Clear
                </Link>
                <button type="submit" className="btn btn-outline-primary">
                    Search
                </button>
            </div>
        </form>
    );
};
